import { gql } from '@apollo/client';

import { BookmarkedSectionOverviewFragment } from 'approot/shared/bookmarks/bookmark.graphql';
import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';
import { interactiveContentStyleBackgroundFragment } from '../activity-builder/styles/styles.graphql';
import {
  studentLessonLandscapeImageFragment,
  studentLessonSquareImageFragment,
} from 'approot/student-lesson/student-lesson.graphql';
import { studentLessonWorksheetsFragment } from 'approot/student-lesson/sections/worksheets/worksheets.graphql';
import { studentLessonStimulusFragment } from 'approot/student-lesson/sections/stimulus/stimulus.graphql';
import { studentLessonPrintablesFragment } from 'approot/student-lesson/sections/printables/printables.graphql';

export const GET_STUDENT_LESSON_ASSIGNMENT_BY_ID = gql`
  query GetStudentLessonAssignmentById($input: GetStudentAssignmentByIdInput!) {
    getStudentAssignmentById(input: $input) {
      id
      contentId
      isAssigned
      isAutomarkable
      studentProgress
      assignedContentData {
        ... on AssignedLessonData {
          stimulusResourceIds
          vocabularyEnPages
          vocabularyEsPages
          activitiesBookmarks {
            version
            sectionIds
          }
        }
      }
      linkedContent {
        ... on Lesson {
          id
          slug
          name
          years {
            name
          }
          unit {
            id
            name
          }
          authorId
          notesJson
          focusQuestion {
            value
          }
          phenomena {
            value
          }
          integratedUnit {
            id
            name
          }
          subjects {
            id
            label
            name
            colour
          }
          ...StudentLessonLandscapeImageFragment
          ...StudentLessonSquareImageFragment
          ...StudentLessonWorksheetsFragment
          ...StudentLessonStimulusFragment
          ...StudentLessonPrintablesFragment
        }
      }
      assignedActivities {
        ... on LessonActivities {
          id
          language
          version
          downloadUrl
          printPdfKey
          availableTranslations
          assetKeys {
            print {
              language
              key
              publicToken
            }
            studentPrintables {
              language
              key
              publicToken
            }
          }
          focusQuestion {
            value
          }
          phenomena {
            value
          }
          landscapeImage {
            alt
            ...ResponsiveImageFragment
          }
          styles {
            fontSize
            ...InteractiveContentStyleBackground
          }
          sectionsOverview {
            ...BookmarkedSectionOverviewFragment
          }
        }
      }
    }
  }
  ${BookmarkedSectionOverviewFragment}
  ${interactiveContentStyleBackgroundFragment}
  ${ResponsiveImageFragment}
  ${studentLessonLandscapeImageFragment}
  ${studentLessonSquareImageFragment}
  ${studentLessonWorksheetsFragment}
  ${studentLessonStimulusFragment}
  ${studentLessonPrintablesFragment}
`;
